import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {DashboardComponent} from "./dashboard/dashboard.component";
import {UsersComponent} from "./users/users.component";
import {CompaniesComponent} from "./companies/companies.component";
import {SettingsComponent} from "./settings/settings.component";
import {UserEditComponent} from "./users/user-edit.component";
import {UserAddComponent} from "./users/user-add.component";
import {UserRoleAddComponent} from "./user-roles/user-role-add.component";
import {UserRoleEditComponent} from "./user-roles/user-role-edit.component";
import {CompanyEditComponent} from "./companies/company-edit.component";
import {CompanyStatusAddComponent} from "./company-status/company-status-add.component";
import {CompanyStatusEditComponent} from "./company-status/company-status-edit.component";
import {SettingAddComponent} from "./settings/setting-add.component";
import {SettingEditComponent} from "./settings/setting-edit.component";
import {UserRolesComponent} from "./user-roles/user-roles.component";
import {CompanyStatusComponent} from "./company-status/company-status.component";
import {CompanyDetailComponent} from "./company-detail/company-detail.component";
import {CompanyAddComponent} from "./companies/company-add.component";
import {CompanyImportComponent} from "./company-import/company-import.component";
import {CompanyCategoryAddComponent} from "./company-category/company-category-add.component";
import {CompanyCategoryComponent} from "./company-category/company-category.component";
import {AuthGuardService} from "./services/auth-guard.service";
import {LoginComponent} from "./login/login.component";
import {CompanyCategoryEditComponent} from "./company-category/company-category-edit.component";
import {CompanyExportComponent} from "./company-export/company-export.component";
import {MailchimpListComponent} from "./mailchimp/mailchimp-list.component";
import {MailchimpListEditComponent} from "./mailchimp/mailchimp-list-edit.component";

import {CompanyVisaComponent} from "./company-visa/company-visa.component";
import {CompanyVisaAddComponent} from "./company-visa/company-visa-add.component";
import {CompanyVisaStatusComponent} from "./company-visa-status/company-visa-status.component";
import { CompanyVisaStatusAddComponent } from './company-visa-status/company-visa-status-add.component';
import { CompanyVisaStatusEditComponent } from './company-visa-status/company-visa-status-edit.component';
import {CompanyVisaEditComponent} from "./company-visa/company-visa-edit.component";

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: '/companies', pathMatch: 'full' },
  { path: 'dashboard' ,  canActivate: [AuthGuardService], component: DashboardComponent },
  //
  { path: 'companies', canActivate: [AuthGuardService], component: CompaniesComponent },
  { path: 'companies/:status', canActivate: [AuthGuardService], component: CompaniesComponent },
  { path: 'company/add', canActivate: [AuthGuardService], component: CompanyAddComponent },
  { path: 'company/edit/:id', canActivate: [AuthGuardService], component: CompanyEditComponent },

  { path: 'company-category', canActivate: [AuthGuardService], component: CompanyCategoryComponent },
  { path: 'company-category/add', canActivate: [AuthGuardService], component: CompanyCategoryAddComponent },
  { path: 'company-category/edit/:id', canActivate: [AuthGuardService], component: CompanyCategoryEditComponent },

  { path: 'company-detail/:id', canActivate: [AuthGuardService], component: CompanyDetailComponent },

  { path: 'company/import', canActivate: [AuthGuardService], component: CompanyImportComponent },
  { path: 'company/export', canActivate: [AuthGuardService], component: CompanyExportComponent },

  { path: 'company-status', canActivate: [AuthGuardService], component: CompanyStatusComponent },
  { path: 'company-status/add', canActivate: [AuthGuardService], component: CompanyStatusAddComponent },
  { path: 'company-status/edit/:id', canActivate: [AuthGuardService], component: CompanyStatusEditComponent },

  { path: 'visa-status', canActivate: [AuthGuardService], component: CompanyVisaStatusComponent },
  { path: 'visa-status/add', canActivate: [AuthGuardService], component: CompanyVisaStatusAddComponent },
  { path: 'visa-status/edit/:id', canActivate: [AuthGuardService], component: CompanyVisaStatusEditComponent },

  { path: 'company-visa', canActivate: [AuthGuardService], component: CompanyVisaComponent },
  { path: 'company-visa/add', canActivate: [AuthGuardService], component: CompanyVisaAddComponent },
  { path: 'company-visa/edit/:id', canActivate: [AuthGuardService], component: CompanyVisaEditComponent },

  { path: 'mailchimp/list', canActivate: [AuthGuardService], component: MailchimpListComponent },
  { path: 'mailchimp/list/edit/:id', canActivate: [AuthGuardService], component: MailchimpListEditComponent },

  { path: 'settings', canActivate: [AuthGuardService], component: SettingsComponent },
  { path: 'setting/add', canActivate: [AuthGuardService], component: SettingAddComponent },
  { path: 'setting/edit/:id', canActivate: [AuthGuardService], component: SettingEditComponent },

  { path: 'users', canActivate: [AuthGuardService], component: UsersComponent },
  { path: 'user/add', canActivate: [AuthGuardService], component: UserAddComponent },
  { path: 'user/edit/:id', canActivate: [AuthGuardService], component: UserEditComponent },

  { path: 'user-roles', canActivate: [AuthGuardService], component: UserRolesComponent },
  { path: 'user-role/add', canActivate: [AuthGuardService], component: UserRoleAddComponent },
  { path: 'user-role/edit/:id', canActivate: [AuthGuardService], component: UserRoleEditComponent },

];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { useHash: true }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/routing.module.ts